module.exports = __webpack_public_path__ + "img/planning.17f262a2.svg";